// npm install --save firebase

import firebase from "firebase/app"; // importuj wszystko z firebase
import "firebase/storage"; //! for store images (magazyn na zdjęcia)
import "firebase/firestore"; //! database (baza danych)

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBQ8A3wAgWD4c1vVYXxrmLE9U7aCu6fEII",
  authDomain: "react-gallery-aa0aa.firebaseapp.com",
  projectId: "react-gallery-aa0aa",
  storageBucket: "react-gallery-aa0aa.appspot.com",
  messagingSenderId: "30116274673",
  appId: "1:30116274673:web:00d780bf2197f8a6866450",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

//! Initialize Storage
const projectStorage = firebase.storage(); // storage na zdjecia

//! Initialize Firesotre
const projectFirestore = firebase.firestore(); //database na url zdjęc

//! Timestamp
// uzyty w useStorage do zapisania daty uploadu
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };

// config z project overview / app / react-gallery
// https://console.firebase.google.com/project/react-gallery-aa0aa/settings/general/web:ZDE0NWMyYWItNmZjYy00ZDNmLThmM2QtYzMxYzVhZDFiNWE1?hl=pl
